<template>
	<div class="product-list-container">
		<!-- 标题和副标题 -->
		<div class="header" v-if="data.value.title.value.text">
			<h2 @click="$router.pushToTab(data.value.title.value.link.url)" :style="{ color: data.value.title.value.color }">{{ data.value.title.value.text }}</h2>
			<p @click="$router.pushToTab(data.value.subTitle.value.link.url)" :style="{ color: data.value.subTitle.value.color }">{{ data.value.subTitle.value.text }}</p>
		</div>

		<!-- 商品列表 -->
		<div class="product-list">
			<div v-for="item in data.value.goodsList.value.list" :title="item.goods_name" :key="item.id" class="product-item" @click="goSku(item.sku_id)">
				<div class="img-wrap"> <img :src="$img(item.sku_image)" alt="Product" /></div>
				<div class="product-info">
					<h3 class="product-name">{{ item.goods_name }}</h3>
					<p class="product-desc">{{ item.introduction }}</p>
					<p class="product-price">
						<span class="num">{{ item.discount_price }}元</span>
						<del>{{ item.market_price }}元</del>
					</p>
				</div>
			</div>
			<div class="bottom-wrap" v-if="data.value.bottomImg.value.url">
				<img :src="$img(data.value.bottomImg.value.url)" @click="$router.pushToTab(data.value.bottomImg.value.link.url)" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'ProductList',
	props: {
		data: {
			type: Object
		},
		title: {
			type: String,
			default: '商品列表'
		},
		subtitle: {
			type: String,
			default: '精选商品'
		},
		products: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {};
	},
	created() {},
	computed: {
		...mapGetters(['defaultGoodsImage'])
	},
	methods: {
		goSku(skuId) {
			this.$router.pushToTab('/sku-' + skuId);
		},
		imageError(index) {
			this.data.value.goodsList.value.list[index].sku_image = this.defaultGoodsImage;
		}
	}
};
</script>

<style lang="scss" scoped>
.product-list-container {
	display: flex;
	flex-direction: row;
	/* 水平排列 */
	align-items: flex-start;
	// align-items: stretch;
	/* 对齐方式 */
	gap: 20px;
	/* 间距 */
	max-width: 1200px;
	/* 调整宽度 */
	margin: 20px auto;
	// padding: 20px;
	/* border: 1px solid #ddd; */
	border-radius: 8px;
	// background-color: #fff;
	/* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
}

.header {
	padding: 10px 0px 10px;
	width: 160px;
	display: flex;
	flex-direction: column;
	align-items: center;
	// justify-content: center;
	background-color: #fff;
	border-left: 2px solid $base-color;

	h2 {
		cursor: pointer;
		color: $base-color !important;
	}

	p {
		cursor: pointer;
	}
}

.header h1 {
	font-size: 24px;
	color: #333;
	margin: 0 0 5px 0;
}

.header p {
	font-size: 14px;
	color: #666;
	margin: 0;
}

.product-list {
	flex: 1 1 auto;
	display: flex;
	flex-direction: row;
	gap: 12px;
	/* 调整商品之间的间距 */
	flex-wrap: wrap;
	/* 允许换行 */
}

.product-item {
	width: 0px;
	flex: 0 0 194px;
	// display: flex;
	// flex-direction: column;
	align-items: center;
	gap: 15px;
	background-color: #fff;
	cursor: pointer;
	transition: all 0.2s linear;

	&:hover {
		z-index: 2;
		-webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
		box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
		-webkit-transform: translate3d(0, -2px, 0);
		transform: translate3d(0, -2px, 0);
	}
}

.img-wrap {
	width: 160px;
	height: 160px;
	margin: 10px auto 0px;
	text-align: center;
	line-height: 160px;

	img {
		max-width: 100%;
		max-height: 100%;
	}
}

.product-info {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.product-name {
	font-size: 14px;
	text-align: center;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	margin: 5px 15px;
}

.product-desc {
	// width: 100%;
	margin: 0 30px 10px;
	height: 20px;
	font-size: 12px;
	color: #b0b0b0;
	text-align: center;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.product-price {
	margin: 0 10px 14px;
	text-align: center;
	color: $base-color;

	del {
		margin-left: 0.5em;
		color: #b0b0b0;
	}
}

.bottom-wrap {
	width: 0px;
	flex: 0 0 100%;
	margin-top: 10px;
	height: 118px;
	cursor: pointer;
	overflow: hidden;

	img {
		max-width: 100%;
	}
}
</style>